<template>
  <swiper :options="detailSwiperConfig" ref="mySwiper">
    <swiper-slide
      v-for="(src, index) in images"
      :key="src"
      class="allow-shrink"
    >
      <img
        class="swiper-lazy pointer h-504"
        :data-src="publicPath(src)"
        alt
        @click="onSlideClick(index)"
        @load="onImageLoad"
      />
    </swiper-slide>
    <template slot="pagination">
      <button
        class="button-reset circle size-64 show-for-medium bg-black c-white carousel-button carousel-button--prev flex-container align-center align-middle mx-32 fade-out-disabled"
        data-prev
      >
        <div class="scale-x--1">
          <svg width="33" height="17" class="inline-block-middle">
            <use xlink:href="#arrow" />
          </svg>
        </div>
      </button>
      <button
        class="button-reset circle size-64 show-for-medium bg-black c-white carousel-button carousel-button--next flex-container align-center align-middle mx-32 fade-out-disabled"
        data-next
      >
        <svg width="33" height="17">
          <use xlink:href="#arrow" />
        </svg>
      </button>
    </template>
  </swiper>
</template>
<script>
import cardCarouselMixin from './mixins/card-carousel-mixin'
import publicPathMixin from './mixins/public-path-mixin'

export default {
  name: 'DetailCarousel',
  mixins: [cardCarouselMixin, publicPathMixin],
  props: {
    images: {
      type: Array,
      default: [],
    },
    onSlideClick: {
      type: Function,
      default: () => {},
    },
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper && this.$refs.mySwiper.$swiper
    },
  },
  methods: {
    onImageLoad() {
      if (this.swiper) {
        this.swiper.update()
      }
    }
  }
}
</script>
